import { TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import { useIssueCategoryTreeSelectData } from "../hooks/useIssueCategoryTreeData";

type CustomFormItemProps = {
  value?: string;
  onChange?: (message: string) => void;
};

/**
 * Wrap it in to a <Form.Item> component. Initial value can be set by providing `initialValue={...}`.
 * @param param0 An object containing `{value, onChange}` where value uses initialValue from <Form.Item> and onChange propagates the input back to <Form.Value>.
 * @returns Provides a `<TreeSelect />` component.
 */
export const IssueSelect: React.FC<CustomFormItemProps> = ({
  value,
  onChange,
}) => {
  const [issues] = useIssueCategoryTreeSelectData();
  const [category, setCategory] = useState<string>(value ?? "");
  const change = (e: string) => {
    setCategory(e);
    onChange(e);
  };

  useEffect(() => {
    setCategory(value ?? "");
  }, [value, issues]);

  return (
    <TreeSelect
      showSearch
      style={{ width: "100%" }}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      allowClear
      treeDefaultExpandAll
      treeData={issues}
      treeNodeFilterProp="title"
      onChange={change}
      value={category}
      onClear={() => change(undefined)}
    />
  );
};
